import { Form, Input, Button, Checkbox, Alert } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { TokenExpiredError } from 'jsonwebtoken';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';
import { Action } from 'typesafe-actions';

import ContainerBox from '../../components/ContainerBox';
import { useTheme } from '../../hook/theme';
import { ApplicationState } from '../../store';
import { cddSelect, cleanState, inscSelect, loginRequest } from '../../store/ducks/auth/actions';
import { cleanStateEstoque } from '../../store/ducks/estoque/actions';
import { clearCart } from '../../store/ducks/estoqueCart/actions';
import { cleanStateMoviEntrada } from '../../store/ducks/movimentacoes/actions';
import { cleanStateMoviSaida } from '../../store/ducks/solicitacoesRetorno/actions';
import { cleanSelect } from '../../store/ducks/transportadoras/actions';
import { SKW_PREFIX } from '../../utils/constants';
import { formProps } from './props';

import { Titulo } from './style';
import { EyeTwoTone, EyeInvisibleOutlined, UserOutlined } from '@ant-design/icons';
import { storagePersist } from 'utils/storagePersist';
import { STORAGE } from 'utils/enums/storage.enum';

const Login: React.FC<any> = () => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const login = useSelector((state: ApplicationState) => state.auth.user);
  const [redirect, setRedirect] = useState<string>('');
  const [form] = useForm();
  const { theme } = useTheme();

  const cddSelecionado = login?.centroDistribuicao?.find((cd) => cd.codCdd);

  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    dispatch(cleanState());
    dispatch(cleanStateEstoque());
    dispatch(cleanStateMoviEntrada());
    dispatch(cleanStateMoviSaida());
    dispatch(cleanSelect());
    dispatch(clearCart());
    storagePersist();
  }, [dispatch]);

  useEffect(() => {
    if (!token && TokenExpiredError) return;

    if (token && perfil !== 'T') {
      setRedirect('/dashboard/movimentacoes');
      localStorage.setItem(STORAGE.Current_screen, '0');
    } else {
      setRedirect('/dashboard/entregaNocd');
      localStorage.setItem(STORAGE.Current_screen, '/entregaNocd0');
      localStorage.setItem(STORAGE.Submenu, 'Área de agendamentos3');
    }
  }, [token, perfil, theme]);

  useEffect(() => {
    dispatch(cddSelect(cddSelecionado));
    const arrayfavorite: Array<number> = [];
    login?.inscricoesEstaduais?.map((item) => {
      if (item.isFavorito === true) arrayfavorite.push(item.codParceiro);
      return false;
    });
    dispatch(inscSelect(arrayfavorite));
    dispatch(clearCart());
    storagePersist();
    // eslint-disable-next-line
  }, [token]);

  const onFinish = (values: formProps) => {
    dispatch(loginRequest({ usuario: values.usuario, senha: values.senha }));
    storagePersist();
  };

  return (
    <ContainerBox>
      {SKW_PREFIX.length > 0 ? <Alert message={SKW_PREFIX} type="error" /> : ''}

      <Titulo>
        <UserOutlined /> Login
      </Titulo>
      <Form name="normal_login" initialValues={{ remember: true }} onFinish={onFinish} form={form}>
        <Form.Item
          name="usuario"
          rules={[{ required: true, message: 'Por favor digite seu usuário!' }]}
        >
          <Input placeholder="Digite seu usuário" />
        </Form.Item>

        <Form.Item
          name="senha"
          rules={[{ required: true, message: 'Por favor digite sua senha!' }]}
        >
          <Input.Password
            placeholder="Digite sua senha"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item>
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>Lembrar acesso</Checkbox>
          </Form.Item>

          <Link to="/recuperarsenha" style={{ paddingLeft: 40 }} className="login-form-forgot">
            Esqueci minha senha
          </Link>
        </Form.Item>

        <Form.Item>
          <Button type="primary" size="large" block htmlType="submit">
            Acessar
          </Button>
        </Form.Item>
      </Form>

      {redirect && <Redirect to={{ pathname: redirect }} />}
    </ContainerBox>
  );
};

export default Login;
